<template>
  <component
    :is="components[multiple ? 'checkboxGroup' : 'radioGroup']"
    v-model="selectedList"
    class="tq-person-selector-choose-group"
  >
    <component
      :is="components[multiple ? 'checkbox' : 'radio']"
      class="tq-person-selector-choose-checkbox"
      v-for="item of data"
      :key="item.personCode"
      :label="item.personCode"
    >
      <div class="person-info">
        <p class="person-name">
          <span v-html="highlightKeyword(item.personName)"></span> -
          <span v-html="highlightKeyword(item.personCode, 'i')"></span>
        </p>
        <el-tooltip
          placement="top"
          effect="dark"
          :show-after="500"
          :content="item.personHierarchy"
        >
          <span
            class="person-hierarchy"
            v-html="highlightKeyword(item.personHierarchy)"
          ></span>
        </el-tooltip>
      </div>
    </component>
  </component>
</template>

<script lang="ts" setup>
import type { PersonSelector } from "../types/index";
import { ref, watch, onBeforeUnmount } from "vue";
import type {WatchStopHandle} from "vue";
import {
  ElCheckboxGroup,
  ElCheckbox,
  ElRadioGroup,
  ElRadio,
} from "element-plus";
const components = {
  checkboxGroup: ElCheckboxGroup,
  checkbox: ElCheckbox,
  radioGroup: ElRadioGroup,
  radio: ElRadio,
};

const props = defineProps<{
  multiple: boolean;
  data: PersonSelector.PersonList[];
  modelValue: string[];
  maxWidth?: number | string;
  keyword?: string;
}>();
const emits = defineEmits(["update:modelValue"]);

const selectedList = ref<any>(props.multiple ? [] : "");
const unwatchList: WatchStopHandle[] = [];
const hierarchyWidth: string = props.maxWidth ? `${props.maxWidth}px` : "230px";

const highlightKeyword = (text: string, rule: string = "ig") => {
  if (props.keyword) {
    return text.replace(
      new RegExp(props.keyword, rule),
      `<span style="color:red">${props.keyword}</span>`
    );
  } else {
    return text;
  }
};
unwatchList.push(
  watch(
    () => props.modelValue,
    (newVal) => {
      selectedList.value = props.multiple ? newVal : newVal[0];
    },
    {
      immediate: true,
      deep: true,
    }
  )
);

unwatchList.push(
  watch(selectedList, (newVal) =>
    emits("update:modelValue", props.multiple ? newVal : [newVal])
  )
);

onBeforeUnmount(() => unwatchList.forEach((unwatch) => unwatch()));
</script>

<style>
.tq-person-selector-choose-group .person-hierarchy {
  max-width: v-bind(hierarchyWidth);
}
</style>